// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29nxn","newExpiryDate":"styles_newExpiryDate__1OWtu","footer":"styles_footer__YnC4j"};